import vaultComponent from './vault.component';
import VaultCreate from './create'
import VaultEdit from './edit'
import VaultAll from './all'

let vaultModule = angular.module('vault', [
    VaultCreate,
    VaultEdit,
    VaultAll
  ])

  .component('vault', vaultComponent)

  .config(($stateProvider, $urlRouterProvider) => {
    "ngInject";

    // $stateProvider
    //   .state('vault.edit', {
    //     url: '/edit/:id',
    //     component: 'vaultedit'
    //   })

    //   .state('vault.create', {
    //     url: '/create',
    //     component: 'vaultcreate'
    //   })

    //   .state('vault.all', {
    //     url: '/all/:page',
    //     component: 'vaultall',
    //   })
  })

  .name;

export default vaultModule;


// WEBPACK FOOTER //
// ./client/app/components/vault/index.js